import React, { Fragment } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { CheckVideo, Oro } from "./views";

function App() {
  return (
    <Router>
      <Fragment>
        <Route exact path="/">
          <Oro />
        </Route>
        <Route exact path="/:id">
          <CheckVideo />
        </Route>
      </Fragment>
    </Router>
  );
}

export default App;
